'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _redux = require('redux');

var _reduxImmutable = require('redux-immutable');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _immutable = require('redux-form/immutable');

var _sagas = require('./sagas');

var sagas = _interopRequireWildcard(_sagas);

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = process.env.NODE_ENV === 'development' ? require('@wh/cs-react-redux-utils') : {},
    createDevMiddlewares = _ref.createDevMiddlewares,
    logger = _ref.logger;

var devMiddlewares = createDevMiddlewares ? createDevMiddlewares(logger()) : [];
var sagaMiddleware = (0, _reduxSaga2.default)();
var middlewares = _redux.applyMiddleware.apply(undefined, [sagaMiddleware].concat((0, _toConsumableArray3.default)(devMiddlewares)));

var reducers = (0, _reduxImmutable.combineReducers)({
  form: _immutable.reducer,
  quickDeposit: _reducer2.default
});

/**
 * Creates the component store
 * @param  {Map<*,*>} initialState the initial state
 * @return {Object}   the store
 */
var createStore = function createStore(initialState) {
  var store = (0, _extends3.default)({}, (0, _redux.createStore)(reducers, initialState, middlewares));

  [].concat((0, _toConsumableArray3.default)((0, _values2.default)(sagas))).forEach(sagaMiddleware.run);

  return store;
};

exports.default = createStore;